import { createRoute } from '@tanstack/react-router'

import { CustomerDetail } from '../pages/CustomerDetail/CustomerDetail'
import { customerRoute } from './CustomerRoute'

export const customerDetailRoute = createRoute({
  getParentRoute: () => customerRoute,
  component: () => <CustomerDetail />,
  path: '/$id'
})
